import { useStore } from 'vuex'
import supportTypeEnum from '../supportTypeEnum'

export default function () {
    const store = useStore()
    const donationFor = store.state.donation.donationFor
    const donationTeam = store.state.donation.donationTeam
    const donationParticipant = store.state.donation.donationParticipant

    return (
        donationFor !== supportTypeEnum.DELTAGER ||
        (donationTeam !== '' && donationParticipant !== '')
    )
}
